const module = {
  config: {
    name: 'dashboard',
    icon: 'ri-dashboard-3-line',
    desc: 'Statistik Aduan',
    layout: true
  },
  routes: [
    { name: 'main-dashboard', label: 'Dashboard', icon: null, path: '/main-dashboard', component: () => import('./main-dashboard.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/dashboard/_index.js